/* BOSC DESIGN v5 */
'use strict';
document.addEventListener('DOMContentLoaded',()=>{
  initAccordions();
  updateCartCount();
});
function updateCartCount(){fetch('/cart.js').then(r=>r.json()).then(cart=>{document.querySelectorAll('.site-header__cart-count').forEach(el=>{el.textContent=cart.item_count;el.hidden=cart.item_count===0;});}).catch(()=>{});}
function formatMoney(cents){return(cents/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'});}
function initAccordions(){document.querySelectorAll('.accordion-btn,.collapsible-item__btn').forEach(btn=>{btn.addEventListener('click',()=>{const item=btn.closest('.accordion-item,.collapsible-item');if(!item)return;item.classList.toggle('open',!item.classList.contains('open'));});});}
document.addEventListener('click',e=>{const playBtn=e.target.closest('.video-section__play');if(!playBtn)return;const wrapper=playBtn.closest('.video-section__media');const iframe=wrapper?.querySelector('iframe');const overlay=playBtn.closest('.video-section__overlay');if(iframe){const src=iframe.src;if(!src.includes('autoplay=1')){iframe.src=src+(src.includes('?')?'&':'?')+'autoplay=1';}if(overlay)overlay.style.display='none';}});

/* ===== Bosc Design — Galerie fiche produit : préchargement + swipe (ajout 2026-07-16) =====
   Corrige : (1) délai de 250-600 ms au 1er affichage d'une photo (aucune image n'était
   préchargée) ; (2) swipe tactile absent sur l'Arsène (désactivé côté thème via
   arsene_legacy_nav). N'affecte PAS le swipe natif des autres produits. */
(function () {
  function initBoscGallery() {
    var hero = document.getElementById('fp-hero-img');
    var strip = [].slice.call(document.querySelectorAll('#fp-gallery .fp-strip__item'));
    if (!hero || !strip.length) return;

    /* 1) Préchargement des photos pleine taille (mêmes URL que celles injectées au clic) */
    var c = navigator.connection || {};
    if (!(c.saveData || /(^|-)2g/.test(c.effectiveType || ''))) {
      var i = 0;
      (function step() {
        if (i >= strip.length) return;
        var it = strip[i++];
        var ss = (it && it.dataset.fullSrcset) || '';
        var urls = ss ? ss.split(',').map(function (p) { return p.trim().split(' ')[0]; })
                      : [it && it.dataset.fullUrl];
        urls.forEach(function (u) { if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; } });
        ('requestIdleCallback' in window) ? requestIdleCallback(step, { timeout: 400 }) : setTimeout(step, 60);
      })();
    }

    /* 2) Swipe tactile — uniquement sur l'Arsène (où le thème le désactive volontairement).
          Réutilise les flèches existantes : comportement identique au clic (défile les photos). */
    var isArsene = /\/products\/applique-arsene(\/|$|\?|#)/.test(location.pathname + location.search + location.hash);
    var stage = document.getElementById('fp-hero');
    var prevBtn = document.getElementById('fp-hero-prev');
    var nextBtn = document.getElementById('fp-hero-next');
    if (isArsene && stage && prevBtn && nextBtn) {
      var x0 = null, y0 = null, t0 = 0;
      stage.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now();
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (Date.now() - t0 > 800) return;
        (dx < 0 ? nextBtn : prevBtn).click();
      }, { passive: true });
    }
  }
  (document.readyState === 'loading')
    ? document.addEventListener('DOMContentLoaded', initBoscGallery)
    : initBoscGallery();
})();
